import { ApolloClient, from, InMemoryCache } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import Constants from "expo-constants";
import * as SecureStore from "@towersystems/roam-common-native/lib/utilities/storage";
import { APP_STATE_KEY } from "./utilities/app-state/constants";
import { Platform } from "react-native";
import { createUploadLink } from "apollo-upload-client";
import { USER_TOKEN_KEY } from "@towersystems/roam-common-native/lib/utilities/authentication";

const errorLink = onError(({ graphQLErrors }) => {
  const e = graphQLErrors && graphQLErrors[0];
  if (e?.message === "error.forbidden") {
    SecureStore.deleteItemAsync(USER_TOKEN_KEY);
    SecureStore.deleteItemAsync(APP_STATE_KEY);
    if (Platform.OS === "web") {
      window.location.href = "/";
    }
  }
});

const httpLinkURI = Constants.manifest?.extra?.apiUrl;

const httpLink = createUploadLink({
  uri: httpLinkURI,
});

const authLink = setContext(async (_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = await SecureStore.getItemAsync(USER_TOKEN_KEY);
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : "",
    },
  };
});

//@ts-ignore
const additiveLink = from([errorLink, authLink, httpLink]);

export const client = new ApolloClient({
  link: additiveLink,
  cache: new InMemoryCache({
    addTypename: false,
  }),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "no-cache",
    },
    query: {
      fetchPolicy: "no-cache",
    },
  },
});
